import Tabs from './Tabs'

export { OptionsNames } from './Tabs'

export default Tabs
